import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalVar } from '../globals/global-var';
import { Register } from '../models/register';

@Injectable({
  providedIn: 'root'
})
export class SelfService {

  constructor(private http: HttpClient, private globalVar: GlobalVar) { }

  postRegisterApi(registerForm: Register): Observable<any> {
    return this.http.post<any>(this.globalVar.targetIp + '/api/self/Register', registerForm);
  }

  putChangePwdApi(changePwdForm: any) {
    return this.http.put<any>(this.globalVar.targetIp + '/api/self/ChangePassword', changePwdForm);
  }

  putChangeImgApi(changeImgData: any) {
    return this.http.put<any>(this.globalVar.targetIp + '/api/self/ChangeImg', changeImgData);
  }
}
